export default class MessageSound {
  constructor() {}

  ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else if (document.addEventListener) {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      document.attachEvent('onreadystatechange', () => {
        if (document.readyState !== 'loading') { fn(); }
      });
    }
  }

  playBell() {
    this.ready(() => {
      const cleverpushAudioTag = document.createElement('audio');
      cleverpushAudioTag.style.display = 'none';
      cleverpushAudioTag.style.visibility = 'hidden';
      cleverpushAudioTag.src = 'https://static.cleverpush.com/sdk/assets/chat-sound.mp3';
      document.body.appendChild(cleverpushAudioTag);
      cleverpushAudioTag.play();
    });
  }
}
